import z from "zod";

export const eventExhibitorsSelectSchema = z.object({
  selectedExhibitors: z.array(z.object({ id: z.string() })),
});

export type EventExhibitorsSelectForm = z.infer<
  typeof eventExhibitorsSelectSchema
>;

export const eventExhibitorsSelectDefaultValues: EventExhibitorsSelectForm = {
  selectedExhibitors: [],
};
